import { __awaiter } from 'tslib';

let preTitle = document.title;
let isLoadDdEntry = false;
const isWeixin = () => !!navigator.userAgent.match(/\bMicroMessenger\b/ig);
const isDingTalk = () => !!navigator.userAgent.match(/\bDingTalk\b/ig);
function setTitle(title) {
    return __awaiter(this, void 0, void 0, function* () {
        if (preTitle === title)
            return title;
        document.title = title;
        preTitle = title;
        if (process.env.SUPPORT_DINGTALK_NAVIGATE !== 'disabled' && isDingTalk()) {
            if (!isLoadDdEntry) {
                isLoadDdEntry = true;
                require('dingtalk-jsapi/platform');
            }
            const setDingTitle = require('dingtalk-jsapi/api/biz/navigation/setTitle').default;
            setDingTitle({ title });
        }
        return title;
    });
}

export { isDingTalk, isWeixin, setTitle };
